import environment from '@environment';

export enum CacheAreaKey {
  Dashboard = 'Dashboard',
  Products = 'Products',
  SelectProducts = 'SelectProducts',
  Account = 'Account',
  Customer = 'Customer',
  Inbox = 'Inbox',
  Rewards = 'Rewards',
  RewardsHistory = 'Rewards History',
  Content = 'Content',
  ChangePackage = 'ChangePackage',
  Payments = 'Payments',
  Profile = 'Profile',
  Bundles = 'Bundles',
  OnDemandDetails = 'OnDemandDetails',
  Currency = 'Currency',
  InternetFLTE = 'InternetFLTE',
  InternetFibre = 'InternetFibre',
  Insurance = 'Insurance',
  FixError = 'FixError',
  Activation = 'Activation',
  Documents = 'Documents',
  LiveChat = 'LiveChat',
  Analytics = 'Analytics',
}

export const CacheConfig = {
  [CacheAreaKey.Products]: {
    key: CacheAreaKey.Products,
    cacheTimeout: environment.CACHE_TIMEOUT_PRODUCTS,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.ChangePackage]: {
    key: CacheAreaKey.ChangePackage,
    cacheTimeout: environment.CACHE_TIMEOUT_CHANGE_PACKAGE,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.SelectProducts]: {
    key: CacheAreaKey.SelectProducts,
    cacheTimeout: environment.CACHE_TIMEOUT_PRODUCTS,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.Account]: {
    key: CacheAreaKey.Account,
    cacheTimeout: environment.CACHE_TIMEOUT_ACCOUNT,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.Customer]: {
    key: CacheAreaKey.Customer,
    cacheTimeout: environment.CACHE_TIMEOUT_CUSTOMER,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.Inbox]: {
    key: CacheAreaKey.Inbox,
    cacheTimeout: environment.CACHE_TIMEOUT_INBOX,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.Rewards]: {
    key: CacheAreaKey.Rewards,
    cacheTimeout: environment.CACHE_TIMEOUT_REWARDS,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.RewardsHistory]: {
    key: CacheAreaKey.RewardsHistory,
    cacheTimeout: environment.CACHE_TIMEOUT_REWARDS,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.Content]: {
    key: CacheAreaKey.Content,
    cacheTimeout: environment.CACHE_TIMEOUT_CONTENT,
    debounceCacheTime: null,
  },
  [CacheAreaKey.Dashboard]: {
    key: CacheAreaKey.Dashboard,
    cacheTimeout: environment.CACHE_TIMEOUT_DASHBOARD,
    debounceCacheTime: null,
  },
  [CacheAreaKey.Payments]: {
    key: CacheAreaKey.Payments,
    cacheTimeout: environment.CACHE_TIMEOUT_PAYMENTS,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.Profile]: {
    key: CacheAreaKey.Profile,
    cacheTimeout: environment.CACHE_TIMEOUT_PROFILE,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.Bundles]: {
    key: CacheAreaKey.Bundles,
    cacheTimeout: environment.CACHE_TIMEOUT_BUNDLES,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.OnDemandDetails]: {
    key: CacheAreaKey.OnDemandDetails,
    cacheTimeout: environment.CACHE_TIMEOUT_ON_DEMAND_SERVICES,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.Currency]: {
    key: CacheAreaKey.Currency,
    cacheTimeout: environment.CACHE_TIMEOUT_CURRENCY,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.InternetFLTE]: {
    key: CacheAreaKey.InternetFLTE,
    cacheTimeout: environment.CACHE_TIMEOUT_CURRENCY,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.InternetFibre]: {
    key: CacheAreaKey.InternetFibre,
    cacheTimeout: environment.CACHE_TIMEOUT_CURRENCY,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.Insurance]: {
    key: CacheAreaKey.Insurance,
    cacheTimeout: environment.CACHE_TIMEOUT_PRODUCTS,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.FixError]: {
    key: CacheAreaKey.FixError,
    cacheTimeout: environment.CACHE_TIMEOUT_FIX_ERROR,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.Activation]: {
    key: CacheAreaKey.Activation,
    cacheTimeout: environment.CACHE_TIMEOUT_PRODUCTS,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.Documents]: {
    key: CacheAreaKey.Documents,
    cacheTimeout: environment.CACHE_TIMEOUT_PRODUCTS,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.LiveChat]: {
    key: CacheAreaKey.LiveChat,
    cacheTimeout: environment.CACHE_TIMEOUT_LIVE_CHAT,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  },
  [CacheAreaKey.Analytics]: {
    key: CacheAreaKey.Analytics,
    cacheTimeout: environment.CACHE_TIMEOUT_CAMPAIGN_ANALYTICS,
    debounceCacheTime: environment.DEFAULT_CACHE_DEBOUNCE,
  }
}